import React from 'react';
import { isMobile } from '@pascal/pascal-core';

export const WheelSectionWrapper = ({ children, results: Results }) => {
  return (
    <div className={isMobile() ? 'mobile-game-content-top' : 'game-center-top'}>
      <div className={isMobile() ? 'mob-g-top-inside' : 'g-c-top-area-ins'}>
        {Results && <Results />}
        <div className={isMobile() ? 'mob-top-m' : 'g-c-top-area-b'}>
          <div className={isMobile() ? 'mob-top-m-ins' : 'game-circle'}>{children}</div>
        </div>
      </div>
    </div>
  );
};
